import React from 'react'
import EasingMotion from './easing-motion'
import { spring } from 'react-motion'
import { SPRING } from '../constants'
import { guardProps } from './validate'

class EasingDot extends React.PureComponent {
  static defaultProps = {
    className: 'easing-dot',
    delay: 0,
    fill: 'rgba(0, 0, 0, 0.25)',
    opacity: 1,
    stroke: 'transparent',
    strokeWidth: 1
  }

  renderDot({ x, y, r }) {
    const { id, className, delay } = this.props

    let style = { animationDelay: delay + 'ms' }

    return (
      <circle id={id} className={className} r={r} cx={x} cy={y} style={style} />
    )
  }

  render() {
    const { x, y, r, fill, opacity, stroke, strokeWidth } = this.props

    if (guardProps(this, 'x', 'y', 'r')) {
      return null
    }

    let style = {
      x: spring(x, SPRING),
      y: spring(y, SPRING),
      r: spring(r, { damping: 13, stiffness: 100, precision: SPRING.precision })
    }

    return (
      <g
        fill={fill}
        strokeWidth={strokeWidth}
        stroke={stroke}
        opacity={opacity}
      >
        <EasingMotion style={style} static={this.props}>
          {style => this.renderDot(style)}
        </EasingMotion>
      </g>
    )
  }
}

export default EasingDot



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/easing-dot.js